import { useSelector } from 'react-redux';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { DMS_PLUS } from '@makemydeal/dr-dash-store/constants';
import * as offerInfoSelectors from '@makemydeal/dr-dash-store/selectors/offerInfoSelectors';
import * as pushToDmsSelectors from '@makemydeal/dr-dash-store/selectors/pushToDmsSelectors';
import { formatAsMMDDYYYY, formatAsTime } from '@makemydeal/dr-common-utils';
import {
    CONFIRM_BUTTON_TEXT,
    PUSH_TO_DMS_BUTTON_TEXT,
    RE_PUSH_TO_DMS_BUTTON_TEXT,
    RESEND_TO_DMS_BUTTON_TEXT
} from './pushToDmsConstants';

export const useLastPushToDmsUpdateText = (hasBeenPushedTime: string | Date) => {
    const isDMSEnabled = useSelector(dealerSelectors.getDMSIntegrationToggle) !== 'OFF';
    const dmsIntegrationToggle = useSelector(dealerSelectors.getDMSIntegrationToggle);
    const offerSaved = useSelector(offerInfoSelectors.getHasBeenSaved);
    const returnedSuccessfulCdmsResponse = useSelector(pushToDmsSelectors.getReturnedSuccessfulCdmsResponse);
    const enableOptionalPbcUi = useSelector(featureToggleSelectors.enableOptionalPbcUi);
    const lastSucceedDmsDealId = useSelector(pushToDmsSelectors.getLastSucceededDmsDealId);
    const lastSucceedDmsTime = useSelector(pushToDmsSelectors.getLastSucceededDmsTime);

    if (!isDMSEnabled) return '';

    if (dmsIntegrationToggle === DMS_PLUS) {
        return '';
    }

    if (!enableOptionalPbcUi && offerSaved && returnedSuccessfulCdmsResponse) {
        return `Deal sent to DT DMS on ${formatAsMMDDYYYY(hasBeenPushedTime as Date)} at ${formatAsTime(
            hasBeenPushedTime as Date
        )}. `;
    }

    if (enableOptionalPbcUi && lastSucceedDmsDealId && lastSucceedDmsTime) {
        const formattedDate = formatAsMMDDYYYY(lastSucceedDmsTime as Date);
        const modifiedDate = formattedDate.slice(0, -4) + formattedDate.slice(-2);
        return `Deal sent to DMS on ${modifiedDate} at ${formatAsTime(lastSucceedDmsTime as Date)}. `;
    }

    return '';
};

export const usePushToDmsButtonText = () => {
    const dmsIntegrationToggle = useSelector(dealerSelectors.getDMSIntegrationToggle);
    const offerSaved = useSelector(offerInfoSelectors.getHasBeenSaved);
    const returnedSuccessfulCdmsResponse = useSelector(pushToDmsSelectors.getReturnedSuccessfulCdmsResponse);
    const lastSucceedDmsDealId = useSelector(pushToDmsSelectors.getLastSucceededDmsDealId);
    const enableOptionalPbcUi = useSelector(featureToggleSelectors.enableOptionalPbcUi);

    if (dmsIntegrationToggle === DMS_PLUS) return PUSH_TO_DMS_BUTTON_TEXT;

    if (enableOptionalPbcUi) {
        return lastSucceedDmsDealId ? RE_PUSH_TO_DMS_BUTTON_TEXT : PUSH_TO_DMS_BUTTON_TEXT;
    }

    return offerSaved && returnedSuccessfulCdmsResponse ? RESEND_TO_DMS_BUTTON_TEXT : PUSH_TO_DMS_BUTTON_TEXT;
};

export const usePushToDmsConfirmButtonText = () => {
    return CONFIRM_BUTTON_TEXT;
};
